var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconFavourites(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.84 3.61C20.3292 3.09901 19.7228 2.69365 19.0554 2.41709C18.3879 2.14052 17.6725 1.99818 16.95 1.99818C16.2275 1.99818 15.5121 2.14052 14.8446 2.41709C14.1772 2.69365 13.5708 3.09901 13.06 3.61L12 4.67L10.94 3.61C9.90831 2.57831 8.50903 1.99871 7.05 1.99871C5.59097 1.99871 4.19169 2.57831 3.16 3.61C2.12831 4.64169 1.54871 6.04097 1.54871 7.5C1.54871 8.95903 2.12831 10.3583 3.16 11.39L4.22 12.45L12 20.23L19.78 12.45L20.84 11.39C21.351 10.8792 21.7564 10.2728 22.0329 9.60536C22.3095 8.9379 22.4518 8.22249 22.4518 7.5C22.4518 6.77751 22.3095 6.06211 22.0329 5.39465C21.7564 4.72719 21.351 4.12076 20.84 3.61V3.61Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFavourites);
export default __webpack_public_path__ + "static/media/icon_favourites.22e3e9e0b4547d2b2b48997c5c88931b.svg";
export { ForwardRef as ReactComponent };